<script setup>
import { ref } from 'vue'
import AppFooter from './AppFooter.vue'
import LegalModal from './LegalModal.vue'

const legalType = ref(null)
</script>

<template>
    <router-view />
    <AppFooter @open-legal="legalType = $event" />
    <LegalModal :type="legalType" @close="legalType = null" />
</template>
